import type { ThemeName } from './types';

export const isThemeName = (value: unknown): value is ThemeName => (
  value === 'midnight' || value === 'daylight'
);

/** Resolves a persisted appearance preference to a valid ThemeName, defaulting to Midnight. */
export const resolveThemeName = (storedPreference: unknown): ThemeName => (
  isThemeName(storedPreference) ? storedPreference : 'midnight'
);
